module.exports = __webpack_public_path__ + "images/McPayCard.9ec727ef299986e9a2a5d74ba7030f84.png";